import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../ApiEndpoint";
import Cookies from 'js-cookie';


const initialState = {
    admin: null,
    token: Cookies.get('token') || null,
    loading: false,
    error: null,
    message: null,
};


export const signup = createAsyncThunk('auth/signup', async (data, { rejectWithValue }) => {
    const { endpoint, payload } = data;
    try {
        const res = await axios.post(BASE_URL + endpoint, payload,);
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

// Async thunk for signin
export const signin = createAsyncThunk('auth/signin', async (data, { rejectWithValue }) => {
    const { endpoint, payload } = data;
    try {
        const response = await axios.post(BASE_URL + endpoint, payload,);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});



const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout: (state) => {
            state.admin = null;
            state.token = null;
            Cookies.remove('token');
        },
    },
    extraReducers: (builder) => {
        // Signup
        builder.addCase(signup.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(signup.fulfilled, (state, action) => {
            state.loading = false;
            state.message = action.payload.message;
            state.admin = action.payload.admin;
        });
        builder.addCase(signup.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Signin
        builder.addCase(signin.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(signin.fulfilled, (state, action) => {
            state.loading = false;
            state.message = action.payload.message;
            state.admin = action.payload.admin;
            state.token = action.payload.token;
        });
        builder.addCase(signin.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});



export const { logout } = authSlice.actions;
export default authSlice.reducer;